module.exports = __webpack_public_path__ + "img/Parasight_parasitic_invasion.06478b24.png";